<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2 translate>installation-error.title</h2>
    </div>
    <button mat-icon-button type="button" mat-dialog-close [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body installation-error-dialog__body">
    <ul>
      <li *ngFor="let error of errors">
        <code>
          <ng-container *ngIf="error.isAlias; else notAlias">
            {{ 'employee.alias' | translate }}: {{ error.employeeEmail }}
          </ng-container>
          <ng-template #notAlias>
            {{ 'employee.employee' | translate }}: {{ error.employeeEmail }}
          </ng-template>
        </code>
        <span> ("{{ error.templateName }}")</span>
        <pre><code>{{ error.error }}</code></pre>
      </li>
    </ul>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" mat-dialog-close>{{ 'close' | translate }}</button>
  </footer>
</div>
